/* ==========================================================================
   DUPE OUTDOORS v16, 2026-10-21. All storefront behaviour in one file.
   Replaces dupe-field.js and dupe-pdp.js. No dependencies.

   header      hide on scroll down, show on up; transparent over the home hero
   drawers     phone menu (left) and cart (right), scrim, Esc, body lock
   cart        /cart.js render, qty +/-, remove, free-shipping meter ($42)
   add         every product form and card quick add goes through /cart/add.js
               and opens the cart drawer; Buy Now goes on to /checkout
   pdp         colour/size pickers, gallery swipe + thumbs, sticky phone bar
   cards       colour swatches swap the photo; "+" opens a size row
   home        filter chips, rail dots/arrows, hotspots, parallax, reveals
   email       customer forms reveal DUPE10 in place; the 10% pop-up
   ========================================================================== */
(function () {
  'use strict';
  var d = document, w = window, body = d.body;
  var FREE = 4200;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : c / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var store = {
    get: function (k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { w.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- header ---------- */
  var hd = $('[data-hd]'), hero = $('[data-hero]');
  if (hero) body.classList.add('dd-home');
  var lastY = w.scrollY, ticking = false;
  function onScroll() {
    var y = w.scrollY;
    if (hd) {
      var overHero = hero && y < hero.offsetHeight - 120;
      hd.classList.toggle('is-over', !!overHero && !body.classList.contains('is-locked'));
      hd.classList.toggle('is-stuck', y > 38);
      var hide = y > 320 && y > lastY + 4 && !body.classList.contains('is-locked');
      var show = y < lastY - 4 || y < 320;
      if (hide) { hd.classList.add('is-hidden'); body.classList.add('dd-hd-hidden'); }
      else if (show) { hd.classList.remove('is-hidden'); body.classList.remove('dd-hd-hidden'); }
    }
    parallax();
    lastY = y; ticking = false;
  }
  w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- drawers / scrim / modal ---------- */
  var scrim = $('[data-scrim]'), openEl = null, lastFocus = null;
  function open(el) {
    if (!el) return;
    if (openEl && openEl !== el) close();
    lastFocus = d.activeElement; openEl = el;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-on');
    body.classList.add('is-locked');
    if (hd) hd.classList.remove('is-over', 'is-hidden');
    var f = $('[data-close], [data-modal-close], button, a', el); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('is-open'); openEl.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-on');
    body.classList.remove('is-locked'); openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    onScroll();
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      e.preventDefault();
      var which = o.getAttribute('data-open');
      if (which === 'cart') { refreshCart(); }
      open($('[data-drawer="' + which + '"]'));
      return;
    }
    var m = e.target.closest('[data-modal-open]');
    if (m) { e.preventDefault(); open($('[data-modal="' + m.getAttribute('data-modal-open') + '"]')); return; }
    if (e.target.closest('[data-close], [data-modal-close]') || e.target === scrim) { close(); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); closePop(); } });

  /* ---------- cart ---------- */
  var cartEl = $('[data-drawer="cart"]');
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) {
      var was = c.getAttribute('data-n');
      c.textContent = n; c.setAttribute('data-n', n);
      if (String(was) !== String(n)) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    });
    var t = $('[data-cart-count-text]'); if (t) t.textContent = n ? '(' + n + ')' : '';
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cartEl) return;
    var lines = $('[data-cart-lines]', cartEl), empty = $('[data-cart-empty]', cartEl), foot = $('[data-cart-foot]', cartEl), ship = $('[data-ship]', cartEl);
    var total = cart.total_price;
    $('[data-cart-total]', cartEl).textContent = money(total);
    var left = FREE - total;
    ship.classList.toggle('is-free', left <= 0);
    $('[data-ship-msg]', cartEl).innerHTML = cart.item_count === 0 ? 'Orders of $42 or more ship free.' : (left > 0 ? 'You\'re <b>' + money(left) + '</b> away from free shipping.' : 'Nice. <b>Your order ships free.</b>');
    $('[data-ship-fill]', cartEl).style.width = Math.min(100, total / FREE * 100) + '%';
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0; ship.hidden = cart.item_count === 0;
    var inCart = {};
    lines.innerHTML = cart.items.map(function (it) {
      inCart[it.handle] = 1;
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var nm = (it.product_title || '').split('(')[0].trim();
      var opt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<div class="dd-line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '"><img class="dd-line__img" src="' + esc(img) + '" alt="" width="84" height="84"></a>' +
        '<div><a class="dd-line__name" href="' + esc(it.url) + '">' + esc(nm) + '</a>' + (opt ? '<p class="dd-line__opt">' + esc(opt) + '</p>' : '') +
        '<div class="dd-qty"><button type="button" data-ch="-1" aria-label="One less">&minus;</button><span>' + it.quantity + '</span><button type="button" data-ch="1" aria-label="One more">+</button></div>' +
        '<button class="dd-line__rm" type="button" data-ch="rm">Remove</button></div>' +
        '<span class="dd-line__price">' + money(it.final_line_price) + '</span></div>';
    }).join('');
    $$('[data-mini]', cartEl).forEach(function (m) { m.hidden = !!inCart[m.getAttribute('data-mini')]; });
  }
  function refreshCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}); }
  if (cartEl) {
    cartEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ch]'); if (!b) return;
      var line = b.closest('[data-key]'); var key = line.getAttribute('data-key');
      var q = parseInt($('.dd-qty span', line).textContent, 10);
      var ch = b.getAttribute('data-ch'); var nq = ch === 'rm' ? 0 : Math.max(0, q + parseInt(ch, 10));
      line.style.opacity = '.5';
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: nq }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(refreshCart);
    });
  }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add that'); return j; }); });
  }
  function addedOpen() { return refreshCart().then(function () { open(cartEl); }); }

  /* ---------- product page ---------- */
  $$('[data-pdp]').forEach(function (pdp) {
    var form = $('[data-dd-product-form]', pdp); if (!form) return;
    var variants = []; try { variants = JSON.parse($('[data-variants]', form).textContent); } catch (e) { return; }
    var idIn = $('[data-variant-id]', form), atc = $('[data-atc]', form), atcLabel = $('[data-atc-label]', form);
    var priceEl = $('[data-price]', pdp), buyNow = $('[data-buy-now]', pdp), sticky = $('[data-sticky]', pdp);
    var opts = $$('[data-opt]', form);
    var current = variants.filter(function (v) { return String(v.id) === idIn.value; })[0] || variants[0];
    var sel = current ? current.o.slice() : [];

    // gallery
    var track = $('[data-gal-track]', pdp), slides = $$('.dd-gal__slide', pdp), thumbs = $$('[data-thumb]', pdp), count = $('[data-gal-count]', pdp);
    var desktop = w.matchMedia('(min-width: 1000px)');
    function goSlide(i, smooth) {
      if (!slides[i]) return;
      if (desktop.matches) {
        if (i > 0) { track.insertBefore(slides[i], track.firstChild); slides = $$('.dd-gal__slide', pdp); }
        w.scrollTo({ top: Math.max(0, pdp.getBoundingClientRect().top + w.scrollY - 90), behavior: smooth ? 'smooth' : 'auto' });
        return;
      }
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }, { passive: true });
      var lead = $('[data-lead]', track); if (lead) { var li = slides.indexOf(lead); if (li > 0) goSlide(li, false); }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(parseInt(t.getAttribute('data-thumb'), 10), true); }); });

    function find() { return variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0]; }
    function markAvailability() {
      // grey out values that have no available variant with the other choices kept
      opts.forEach(function (o) {
        var pos = parseInt(o.getAttribute('data-opt'), 10);
        $$('[data-val]', o).forEach(function (b) {
          var val = b.getAttribute('data-val');
          var ok = variants.some(function (v) { return v.a && v.o[pos] === val && v.o.every(function (x, i) { return i === pos || x === sel[i]; }); });
          b.classList.toggle('is-out', !ok);
        });
      });
    }
    function update(fromColour) {
      var v = find();
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      current = v; idIn.value = v.id;
      atc.disabled = !v.a; atcLabel.textContent = v.a ? 'Add to cart · ' + money(v.p) : 'Sold out';
      if (buyNow) buyNow.disabled = !v.a;
      if (priceEl) priceEl.textContent = money(v.p);
      if (sticky) { var sm = $('[data-sticky-meta]', sticky); if (sm) sm.textContent = v.o.join(' / ') + ' · ' + money(v.p); }
      if (fromColour && v.m) {
        var i = -1; slides.forEach(function (s, k) { if (s.getAttribute('data-media') === String(v.m)) i = k; });
        if (i >= 0) goSlide(i, true);
      }
      try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u); } catch (e) { /* old browser */ }
      markAvailability();
    }
    opts.forEach(function (o) {
      var pos = parseInt(o.getAttribute('data-opt'), 10);
      $$('[data-val]', o).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-val]', o).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
          b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
          var lab = $('[data-opt-val]', o); if (lab) lab.textContent = b.getAttribute('data-val');
          sel[pos] = b.getAttribute('data-val');
          update(b.classList.contains('dd-colour'));
        });
      });
    });
    if (current && current.a) atcLabel.textContent = 'Add to cart · ' + money(current.p);
    markAvailability();

    // quantity
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('input[name="quantity"]', form) || d.getElementById(form.id.replace('product-form-', 'Quantity-'));
        var q = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10)); inp.value = q;
      });
    });
    function qty() { var inp = d.querySelector('input[name="quantity"][form="' + form.id + '"]') || $('input[name="quantity"]', form); return Math.max(1, parseInt(inp && inp.value, 10) || 1); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      atc.setAttribute('aria-busy', 'true');
      addItems([{ id: current.id, quantity: qty() }])
        .then(addedOpen)
        .catch(function (err) { toast(err.message); })
        .then(function () { atc.removeAttribute('aria-busy'); });
    });
    if (buyNow) buyNow.addEventListener('click', function () {
      buyNow.setAttribute('aria-busy', 'true'); buyNow.textContent = 'Taking you to checkout…';
      addItems([{ id: current.id, quantity: qty() }])
        .then(function () { w.location.href = buyNow.getAttribute('data-checkout-url'); })
        .catch(function () { form.submit(); });
    });

    // sticky phone bar
    if (sticky && 'IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { var past = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); });
      });
      io.observe(atc);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        var sizeOpt = opts.filter(function (o) { return $('.dd-sizes', o); })[0];
        if (sizeOpt && !$('.dd-size.is-on', sizeOpt)) { sizeOpt.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  });

  /* ---------- product cards ---------- */
  d.addEventListener('click', function (e) {
    var sw = e.target.closest('.dd-sw');
    if (sw) {
      var card = sw.closest('[data-card]');
      $$('.dd-sw', card).forEach(function (s) { s.classList.remove('is-on'); });
      sw.classList.add('is-on');
      var img = $('[data-card-img]', card), src = sw.getAttribute('data-img');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      card.setAttribute('data-colour', sw.getAttribute('data-colour'));
      if (card.classList.contains('is-picking')) cardSizes(card);
      return;
    }
    var qa = e.target.closest('[data-qa]');
    if (qa) {
      var c = qa.closest('[data-card]');
      var on = !c.classList.contains('is-picking');
      $$('.dd-card.is-picking').forEach(function (x) { x.classList.remove('is-picking'); $('[data-qa]', x).setAttribute('aria-expanded', 'false'); });
      if (on) { cardSizes(c); c.classList.add('is-picking'); qa.setAttribute('aria-expanded', 'true'); }
      return;
    }
    var sb = e.target.closest('[data-sizes] button');
    if (sb) {
      var cc = sb.closest('[data-card]'), v = cardVariant(cc, sb.getAttribute('data-size'));
      if (!v) return;
      sb.classList.add('is-ok');
      addItems([{ id: v.id, quantity: 1 }]).then(function () {
        setTimeout(function () { cc.classList.remove('is-picking'); sb.classList.remove('is-ok'); }, 500);
        return addedOpen();
      }).catch(function (err) { sb.classList.remove('is-ok'); toast(err.message); });
      return;
    }
    if (!e.target.closest('.dd-card')) $$('.dd-card.is-picking').forEach(function (x) { x.classList.remove('is-picking'); });
  });
  if (w.matchMedia('(hover: hover)').matches) {
    d.addEventListener('mouseover', function (e) { var sw = e.target.closest && e.target.closest('.dd-sw'); if (sw && !sw.classList.contains('is-on')) sw.click(); });
  }
  function cardData(card) {
    if (!card._v) { try { card._v = JSON.parse($('[data-v]', card).textContent); card._p = JSON.parse($('[data-pos]', card).textContent); } catch (e) { card._v = []; card._p = { c: -1, s: -1 }; } }
    return card;
  }
  function cardColour(card) { var on = $('.dd-sw.is-on', card); return on ? on.getAttribute('data-colour') : null; }
  function cardVariant(card, size) {
    cardData(card); var col = cardColour(card);
    return card._v.filter(function (v) { return v.o[card._p.s] === size && (card._p.c < 0 || v.o[card._p.c] === col); })[0];
  }
  function cardSizes(card) {
    cardData(card); var col = cardColour(card);
    var lab = $('[data-qa-colour]', card); if (lab) lab.textContent = col ? ' · ' + col : '';
    $$('[data-sizes] button', card).forEach(function (b) { var v = cardVariant(card, b.getAttribute('data-size')); b.disabled = !(v && v.a); });
  }

  /* ---------- home: filter chips ---------- */
  $$('[data-filter]').forEach(function (bar) {
    var grid = bar.parentNode.querySelector('[data-grid]');
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]'); if (!b) return;
      $$('[data-f]', bar).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-selected', 'false'); });
      b.classList.add('is-on'); b.setAttribute('aria-selected', 'true');
      var f = b.getAttribute('data-f');
      $$('[data-card]', grid).forEach(function (c, i) {
        var show = !f || (' ' + c.getAttribute('data-groups') + ' ').indexOf(' ' + f + ' ') > -1;
        c.classList.toggle('is-hide', !show);
        if (show) { c.classList.remove('is-in'); setTimeout(function () { c.classList.add('is-in'); }, 30 + (i % 8) * 40); }
      });
    });
  });

  /* ---------- rails: the post's BACK 01 02 03 NEXT arrow pager ---------- */
  $$('[data-rail]').forEach(function (rail) {
    var key = rail.getAttribute('data-rail'), pager = $('[data-pager="' + key + '"]');
    if (!pager) return;
    var items = Array.prototype.slice.call(rail.children);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    pager.innerHTML = '<button type="button" data-dir="-1">Back</button><div class="dd-pager__line"><i></i>' +
      items.map(function (_, i) { return '<b data-go="' + i + '">' + pad(i + 1) + '</b>'; }).join('') +
      '</div><button type="button" data-dir="1">Next</button>';
    var nums = $$('[data-go]', pager), back = $('[data-dir="-1"]', pager), next = $('[data-dir="1"]', pager);
    function step() { return items[1] ? items[1].offsetLeft - items[0].offsetLeft : rail.clientWidth; }
    function at() { return Math.max(0, Math.min(items.length - 1, Math.round(rail.scrollLeft / step()))); }
    function mark() {
      var i = at(), end = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      if (end) i = items.length - 1;
      nums.forEach(function (n, k) { n.classList.toggle('is-on', k === i); });
      back.disabled = rail.scrollLeft < 4; next.disabled = end;
      pager.hidden = rail.scrollWidth <= rail.clientWidth + 4;
    }
    function go(i) { rail.scrollTo({ left: step() * i, behavior: reduce ? 'auto' : 'smooth' }); }
    rail.addEventListener('scroll', function () { w.requestAnimationFrame(mark); }, { passive: true });
    pager.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dir]'); if (b) { go(at() + parseInt(b.getAttribute('data-dir'), 10)); return; }
      var n = e.target.closest('[data-go]'); if (n) go(parseInt(n.getAttribute('data-go'), 10));
    });
    mark(); w.addEventListener('resize', mark);
  });

  /* ---------- hotspots: keep them on the shirt when object-fit crops ---------- */
  function placeSpots() {
    $$('[data-spot]').forEach(function (s) {
      var box = s.parentNode, img = $$('img', box).filter(function (i) { return i.offsetParent !== null || i.closest('picture'); })[0];
      if (!img || !img.naturalWidth) return;
      var bw = box.clientWidth, bh = box.clientHeight, iw = img.naturalWidth, ih = img.naturalHeight;
      var sc = Math.max(bw / iw, bh / ih), ox = (bw - iw * sc) / 2, oy = (bh - ih * sc) / 2;
      var x = parseFloat(s.getAttribute('data-x')) / 100 * iw * sc + ox, y = parseFloat(s.getAttribute('data-y')) / 100 * ih * sc + oy;
      s.style.left = x + 'px'; s.style.top = y + 'px';
    });
  }
  $$('[data-spot]').forEach(function (s) {
    var img = $$('img', s.parentNode)[0];
    if (img && !img.complete) img.addEventListener('load', placeSpots);
    $('.dd-spot__dot', s).addEventListener('click', function () {
      var was = s.classList.contains('is-open');
      $$('[data-spot].is-open').forEach(function (x) { x.classList.remove('is-open'); });
      if (!was) s.classList.add('is-open');
    });
  });
  placeSpots();
  w.addEventListener('resize', placeSpots);

  /* ---------- parallax (story band) ---------- */
  var pars = $$('[data-parallax] img');
  function parallax() {
    // onScroll() runs once at boot, before this var is assigned (hoisting), so guard for undefined
    if (reduce || !pars || !pars.length) return;
    var vh = w.innerHeight;
    pars.forEach(function (img) {
      var r = img.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh; img.style.transform = 'translate3d(0,' + (p * -7) + '%,0)';
    });
  }

  /* ---------- reveal on scroll ---------- */
  var rv = $$('[data-rv]');
  if ('IntersectionObserver' in w && !reduce) {
    var rio = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { rio.observe(el); });
  } else rv.forEach(function (el) { el.classList.add('is-in'); });

  /* ---------- email signup (Shopify customer form) ---------- */
  $$('form[data-dd-signup]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('button[type="submit"]', f); if (btn) btn.setAttribute('aria-busy', 'true');
      fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok || /challenge/.test(r.url)) throw new Error('fallback');
          f.hidden = true; var ok = f.parentNode.querySelector('[data-signup-ok]'); if (ok) ok.hidden = false;
          store.set('dd-signed', '1');
        })
        .catch(function () { f.submit(); });
    });
  });

  /* ---------- 10% pop-up: once, after 30s or 70% of the page ---------- */
  var pop = $('[data-pop]'), popShown = false;
  function showPop() {
    if (!pop || popShown || store.get('dd-pop') || store.get('dd-signed') || openEl) return;
    popShown = true; pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
  }
  function closePop() { if (!pop || !pop.classList.contains('is-open')) return; pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true'); store.set('dd-pop', '1'); }
  if (pop) {
    setTimeout(showPop, 30000);
    w.addEventListener('scroll', function () { if ((w.scrollY + w.innerHeight) / d.documentElement.scrollHeight > 0.7) showPop(); }, { passive: true });
    $('[data-pop-close]', pop).addEventListener('click', closePop);
  }

  /* first paint of the drawer from the live cart, so counts are right after back/forward */
  w.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
